import React, { useEffect, useState } from "react";

export default function AboutMe({ aboutMeAnimation }) {
  const [cssClassName, setCssClassName] = useState("overlaycontainer");

  useEffect(() => {
    if (aboutMeAnimation) {
      return setCssClassName("overlaycontainer fadeIn");
    } else {
      setCssClassName("overlaycontainer");
    }
  }, [aboutMeAnimation]);

  return (
    <div
      className={cssClassName}
      style={{ pointerEvents: aboutMeAnimation ? "all" : "none" }}
    >
      <p>About Section</p>
    </div>
  );
}
